import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';
import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './InviteInfoFns'
import InviteInfoUpsertPage from './InviteInfoUpsertPage'
import langObj from '../TopUserLang'
import './InviteInfo.scss';


function InviteInfo(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const { TextArea } = Input
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isContentLoading, setIsContentLoading] = useState(false)
  const [inviteInfoMap, setInviteInfoMap] = useState({})
  const [mode, setMode] = useState('CN');
  const [form] = Form.useForm();
  const setFuncMap = {
    message, setMode, setIsPageLoading, setIsContentLoading, setInviteInfoMap
  }
  const handleModeChange = (e) => {
    setMode(e.target.value);
  };
  useEffect(() => {

    efn.getConference(props, setFuncMap)
    efn.getInviteInfos(props, setFuncMap)

  }, []);

  return (
    <Spin spinning={isPageLoading}>
      <div className="InviteInfo">
        <Spin spinning={isContentLoading}>
          <Radio.Group
            onChange={handleModeChange}
            value={mode}
            style={{
              marginBottom: 8,
            }}
          >
            {langObj.langs.map((lang, key) => {
              return <Radio.Button key={key} value={lang.key} style={{ background: lang.color }}>{lang.key}</Radio.Button>
            })}
          </Radio.Group>
          {langObj.langs.map((lang, key) => {
            return <div className={`upsert-page ${mode != lang.key ? "hide" : ""}`}>
              <InviteInfoUpsertPage
                key={key} lang={lang.key} conferenceUid={props.conferenceUid}
                inviteInfoMap={inviteInfoMap} setFuncMap={setFuncMap} /></div>
          })}
        </Spin>
      </div>
    </Spin>
  );
}



export default InviteInfo;
